import rhinoCore from 'rhino/src/core/core.module';
import * as rnSearch from './search.service.js';

export default angular.module('rhino.components.search', [rhinoCore])
  .service(rnSearch.name, rnSearch.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/search/search.module.js